import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Sidebar from "@/components/Sidebar";
import AppFooter from "@/components/AppFooter";
import ModuleSwitcher from "@/components/ModuleSwitcher";

export default function AppLayout({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return (
    <div className="flex min-h-screen bg-[#F5F7FA]">
      <Sidebar />
      <main className="flex-1 overflow-auto flex flex-col" data-testid="main-content">
        {/* Top bar with the global module switcher */}
        <header className="sticky top-0 z-10 bg-[#F5F7FA]/90 backdrop-blur border-b border-slate-200 px-6 py-3 flex items-center justify-between">
          <ModuleSwitcher />
          <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-slate-400">
            IQ-APP · Project Analyzer
          </div>
        </header>
        <div className="flex-1">{children}</div>
        <AppFooter />
      </main>
    </div>
  );
}
